templates = require 'app/scripts/views/internal/templates'
View = require 'app/scripts/views/internal/view'

class LabelLimitsErrorView extends View
    tagName: 'span'
    className: 'error'
    renderOnce: ->
      @$el.html(templates.fill('label_limit_exceeded'))


module.exports = LabelLimitsErrorView
